"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = require("styled-components");

var _togaTheme = require("@thinkific/toga-theme");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var inlineAlertCSS = (0, _styledComponents.css)(_templateObject(), function (_ref) {
  var _theme$color;

  var theme = _ref.theme,
      type = _ref.type;
  return (theme === null || theme === void 0 ? void 0 : (_theme$color = theme.color) === null || _theme$color === void 0 ? void 0 : _theme$color[type]) && (0, _togaTheme.isColor)(theme.color[type]) && "\n    background-color: ".concat((0, _togaTheme.fadedColor)(theme.color[type]), ";\n    color: ").concat((0, _togaTheme.accessibleTextColor)(theme.color[type], (0, _togaTheme.fadedColor)(theme.color[type])), ";\n\n    svg {\n      fill: ").concat(theme.color[type], ";\n    }\n  ");
});
var _default = inlineAlertCSS;
exports["default"] = _default;